


















import { UserAccount } from 'sp-common/src/types/core';
import { getAppRelease } from 'sp-common/src/utils';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

import GlobalFooter from '@/components/GlobalFooter.vue';
import GlobalHeader from '@/components/GlobalHeader.vue';
import OptiLegend from '@/components/OptiLegend.vue';
import RouteView from '@/pages/commons/route-view.vue';
import { MixinDevice } from '@/utils';
import { analyticsTrack } from '@/utils/usageAnalytics';

const auth = namespace('auth');

@Component({
  components: {
    RouteView,
    GlobalHeader,
    GlobalFooter,
    OptiLegend,
  },
})
export default class OptiLayout extends MixinDevice {
  appRelease = getAppRelease();
  @auth.State user!: UserAccount;
  @auth.State loggedIn!: boolean;
  @auth.Action logout: any;

  get showBackToHome() {
    const route = this.$route.name;
    return route !== 'start';
  }
  get showSparkLink() {
    return document.referrer.includes('app.sparkcommodities.com');
  }

  get legendVisible() {
    return this.$route.name === 'form-results';
  }
  async handleLogout() {
    analyticsTrack('HEADER_LOGOUT_BTN_CLICKED');
    await this.logout();
    this.$router.push({ path: '/logout' });
  }

  handleBackClick() {
    analyticsTrack('HEADER_BACK_BTN_CLICKED');
  }
  handleLogoClick() {
    analyticsTrack('HEADER_LOGO_CLICKED');
  }
  handleSparkLink() {
    analyticsTrack('HEADER_SPARK_LINK');
    // location.href = 'https://app.sparkcommodities.com';
  }
}
